import OstroDynamicContent from 'app/components/OstroDynamicContent';
import { logInfo } from 'app/services/logger';

import { ContactFormInput } from './ContactFormInput';
import {
  ContactFormItem,
  FormItemButton,
  FormItemInput,
  FormItemSingleChoice,
  FormItemType,
  FormItemCheckbox,
} from '../types';
import { ContactFormSingleChoice } from './ContactFormSingleChoice';
import { ContactFormMultiChoice } from './ContactFormMultiChoice';
import { ContactFormCheckbox } from './ContactFormCheckbox';
import ContactFormButtonFactory from './ContactFormButtonFactory';

type Props = {
  item: ContactFormItem;
  isSubmitted: boolean;
  hasErrors: boolean;
  isValid: boolean;
  isFetching: boolean;
  buttonVariant: 'default' | 'convoai';
  onClickCancel?: () => void;
  isComplete: boolean;
  showSpacer?: boolean;
  dirtyFields: string[];
  setFieldDirty: (field: string) => void;
  contactFormSlug?: string;
};

export default function ContactFormItemFactory({
  item,
  isSubmitted,
  hasErrors,
  isValid,
  isFetching,
  buttonVariant,
  onClickCancel,
  isComplete,
  showSpacer = false,
  dirtyFields,
  setFieldDirty,
  contactFormSlug,
}: Props) {
  switch (item.item_type) {
    case FormItemType.text: {
      return (
        <>
          <input
            type="hidden"
            name={item.ref_id}
            value="true"
          />
          <OstroDynamicContent
            dangerouslySetInnerHTML={{ __html: item.label }}
            className="[&_h1]:mb-0 [&_p]:mb-0"
          />
        </>
      );
    }

    case FormItemType.button: {
      return (
        <ContactFormButtonFactory
          item={item as FormItemButton}
          variant={buttonVariant}
          hasErrors={hasErrors}
          isValid={isValid}
          disabled={isFetching}
          onClickCancel={onClickCancel ?? (() => {})}
          isComplete={isComplete}
        />
      );
    }

    case FormItemType.input: {
      return (
        <ContactFormInput
          item={item as FormItemInput}
          isSubmitted={isSubmitted}
          isDirty={dirtyFields.includes(item.ref_id)}
          onChange={() => setFieldDirty(item.ref_id)}
        />
      );
    }

    case FormItemType.dynamic_spacer: {
      return showSpacer ? <div className="grow" /> : null;
    }

    case FormItemType.choice: {
      return item.selector_type === 'single' ? (
        <ContactFormSingleChoice
          item={item as FormItemSingleChoice}
          isSubmitted={isSubmitted}
        />
      ) : (
        <ContactFormMultiChoice
          item={item as FormItemSingleChoice}
          isSubmitted={isSubmitted}
        />
      );
    }
    case FormItemType.checkbox: {
      return (
        <ContactFormCheckbox
          item={item as FormItemCheckbox}
          isSubmitted={isSubmitted}
          contactFormSlug={contactFormSlug}
        />
      );
    }
    default: {
      logInfo('Item type:', item.item_type, 'not implemented');
      return null;
    }
  }
}
